module.exports = __webpack_public_path__ + "img/04_kii_01.89059818.jpg";